"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/27
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.onMessageListener = onMessageListener;
exports.setOnMessage = setOnMessage;
exports.restoreOnMessage = restoreOnMessage;
exports.getStoredData = getStoredData;
exports.clearStoredData = clearStoredData;
const tslib_1 = require("tslib");
const logger_1 = tslib_1.__importDefault(require("../logger"));
const constants_1 = require("../constants");
const internal_1 = require("./internal");
const files_1 = require("../files");
const storedData = [];
function defaultMessageListener(data) {
    logger_1.default.log("default listener, please execute the `initialise` where you provide the `onMessage` listener", data);
    // store messages for the moment when the partner listener will be set
    storedData.push(data);
}
/**
 * Default partner onMessage function;
 *  this will/should be overwritten when setOnMessage is called with the new function
 * @param {MessageData} data
 */
let partnerOnMessage = defaultMessageListener;
/**
 * Message listener
 *
 * @param {MessageEvent} evt
 */
function onMessageListener(evt) {
    const { type, message, schemaVersion } = evt.data;
    if (type === constants_1.INTERNAL_MESSAGE_TYPE) {
        // this type of message is internal for the SDK
        (0, internal_1.handleSdkMessage)(message);
    }
    else {
        if (type === constants_1.RECEIVE_DATA_TYPES.FILE_TRANSFER) {
            // this is a file transfer message that we want to handle internally (construct the file),
            //  however we also want to let it pass through the partner onMessage listener
            const handleFileTransferMessage = (0, files_1.createFileReceiveFunction)(constants_1.INSTANCE_ID);
            handleFileTransferMessage({ type, message, schemaVersion }, partnerOnMessage);
        }
        partnerOnMessage({ type, message, schemaVersion });
    }
}
/**
 * Set the listener received from the partner.
 *  Also send all the messages received prior to this point.
 * @param {MessageListener} callback
 */
function setOnMessage(callback) {
    if (typeof callback === "function") {
        partnerOnMessage = callback;
        while (storedData.length > 0) {
            // send messages in the order that they have been received
            const message = storedData.shift();
            partnerOnMessage(message);
        }
        return true;
    }
    logger_1.default.error("onMessage should be a function");
    return false;
}
function restoreOnMessage() {
    partnerOnMessage = defaultMessageListener;
}
function getStoredData() {
    return storedData;
}
function clearStoredData() {
    storedData.length = 0;
}
//# sourceMappingURL=receive.js.map